/**
 * Numeric Temporal activity options a per-account override may set per plugin step.
 * Mirrors `pluginStepTemporalOptionsSchema` in @insio/plugin-sdk — keep the two in sync.
 */
export const PluginStepTemporalOptionKey = {
  START_TO_CLOSE_TIMEOUT_MS: 'startToCloseTimeoutMs',
  MAXIMUM_ATTEMPTS: 'maximumAttempts',
  INITIAL_INTERVAL_MS: 'initialIntervalMs',
  BACKOFF_COEFFICIENT: 'backoffCoefficient'
} as const;

export type PluginStepTemporalOptionKey =
  (typeof PluginStepTemporalOptionKey)[keyof typeof PluginStepTemporalOptionKey];

/** Option keys in display order — config UIs (AMS) render one input per key. */
export const PLUGIN_STEP_TEMPORAL_OPTION_KEYS: readonly PluginStepTemporalOptionKey[] =
  Object.values(PluginStepTemporalOptionKey);
